import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const RESET_FILTERS_USER_LIST = "RESET_FILTERS_USER_LIST";

export interface ResetFiltersUserListAction extends Action {
  type: typeof RESET_FILTERS_USER_LIST;
  organization: OrganizationKeyName;
}

export const resetFiltersUserListAction = (
  organization: OrganizationKeyName
): ResetFiltersUserListAction => ({
  type: RESET_FILTERS_USER_LIST,
  organization,
});
